import styled from "styled-components";
import { black, gray, grayDark, white } from "../styles/colors";
import { SAMPLE_POSTER_SRC, SAMPLE_VIDEO_SRC } from "../constants/media";
import { PhoneFrame } from "./PhoneFrame";
import { ScrollReveal } from "./ScrollReveal";
import { StoreBadges } from "./StoreBadges";

export function Hero() {
  return (
    <Section id="top">
      <Grid>
        <Copy>
          <ScrollReveal initialVisible>
            <Pill>Personal progress, on video</Pill>
            <Title>
              Your progress deserves
              <br />a timeline
            </Title>
            <Subtitle>
              Progress helps you capture the daily steps of any journey — from
              first attempt to breakthrough — and turn them into a story you&apos;ll
              want to rewatch.
            </Subtitle>
            <StoreBadges size="large" />
          </ScrollReveal>
        </Copy>
        <Visual>
          <ScrollReveal delay={1} initialVisible>
            <Glow />
            <PhoneFrame
              id="hero"
              posterSrc={SAMPLE_POSTER_SRC}
              videoSrc={SAMPLE_VIDEO_SRC}
              alt="Recording a daily progress step in the app"
            />
          </ScrollReveal>
        </Visual>
      </Grid>
      <ScrollHint href="#story" aria-label="Scroll to learn more">
        <span>See how it works</span>
        <Arrow>↓</Arrow>
      </ScrollHint>
    </Section>
  );
}

const Section = styled.section({
  minHeight: "100vh",
  padding: "120px 24px 80px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  position: "relative",
  background: white,
  color: black,
});

const Grid = styled.div({
  maxWidth: 1100,
  margin: "0 auto",
  width: "100%",
  display: "grid",
  gridTemplateColumns: "1.05fr 0.95fr",
  gap: 48,
  alignItems: "center",

  "@media (max-width: 900px)": {
    gridTemplateColumns: "1fr",
    gap: 56,
    textAlign: "center",
  },
});

const Copy = styled.div({});

const Pill = styled.span({
  display: "inline-block",
  marginBottom: 20,
  padding: "8px 14px",
  borderRadius: 999,
  background: "rgba(35, 35, 35, 0.06)",
  fontSize: 13,
  fontWeight: 700,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: grayDark,
});

const Title = styled.h1({
  margin: "0 0 20px",
  fontSize: "clamp(42px, 6vw, 68px)",
  fontWeight: 700,
  lineHeight: 1.05,
  letterSpacing: "-0.04em",
});

const Subtitle = styled.p({
  margin: "0 0 36px",
  maxWidth: 520,
  fontSize: "clamp(18px, 2.2vw, 21px)",
  lineHeight: 1.7,
  color: grayDark,

  "@media (max-width: 900px)": {
    margin: "0 auto 36px",
  },
});

const Visual = styled.div({
  position: "relative",
  display: "flex",
  justifyContent: "center",
  width: "100%",
});

const Glow = styled.div({
  position: "absolute",
  inset: "10% 5%",
  background:
    "radial-gradient(circle at center, rgba(171, 171, 171, 0.28) 0%, transparent 70%)",
  filter: "blur(24px)",
  pointerEvents: "none",
});

const ScrollHint = styled.a({
  position: "absolute",
  bottom: 24,
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 6,
  fontSize: 12,
  fontWeight: 600,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: gray,
  animation: "float 3s ease-in-out infinite",

  "&:hover": {
    color: black,
  },
});

const Arrow = styled.span({
  fontSize: 18,
  lineHeight: 1,
});
